module.exports = __webpack_public_path__ + "static/img/about.ae2e3a48.png";